import React from 'react';
import { StacklineTheme, hexToRgba } from '@stackline/ui';

export interface StackedTopEntityHoverTooltipProps {
  theme: StacklineTheme;
  title: string;
  color: string;
  tooltipCategoryTitle?: string;
  value: number;
  percentage: string;
}

/**
 * Tooltip to be displayed when hovering stacked chart
 *
 * NOTE: This must use pure HTML elements because it will
 * be converted into a string. This is because the Highcharts
 * tooltip formatter expects a string, not JSX.
 */
const StackedTopEntityHoverTooltip = ({
  title,
  theme,
  color,
  tooltipCategoryTitle,
  value,
  percentage
}: StackedTopEntityHoverTooltipProps) => {
  const fontFamily = {
    fontFamily: 'Roboto'
  };

  return (
    <div
      style={{
        padding: '8px',
        boxShadow: `0 0 4px 0 ${hexToRgba('#000000', 0.15)}`,
        backgroundColor: 'white',
        color: theme.colors.primary,
        borderRadius: '4px',
        minWidth: '115px',
        ...fontFamily
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ width: '8px', height: '8px', backgroundColor: color, borderRadius: '50%' }}></div>
        <div
          style={{
            fontSize: '18px',
            fontWeight: 500,
            marginLeft: '8px'
          }}
        >
          {title}
        </div>
      </div>
      <div style={{ marginTop: '8px', color: '#adbdcc', fontSize: '10px', fontWeight: 500 }}>
        {tooltipCategoryTitle}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', color: theme.colors.primary, marginTop: '4px' }}>
        <div style={{ fontSize: '16px', fontWeight: 500 }}>{value}</div>
        <div style={{ marginLeft: '4px', fontSize: '10px', fontWeight: 500 }}>({percentage})</div>
      </div>
    </div>
  );
};

export default StackedTopEntityHoverTooltip;
